import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage, defineMessage } from 'react-intl';

import { transferMarket } from '@sorare/core/src/lib/glossary';

import { SectionTitle } from '#src/components/mySorare/TransactionsHistory/common/ui.tsx';
import { TokenName } from '#src/components/token/TokenName/index.tsx';

import type { TransactionsPrimaryOffer_tokenPrimaryOffer } from './__generated__/index.graphql.ts';

const message = defineMessage({
  defaultMessage: 'Cards in cart',
});

type Props = {
  tokenPrimaryOffer: TransactionsPrimaryOffer_tokenPrimaryOffer;
};

export const TransactionsPrimaryOffer = ({ tokenPrimaryOffer }: Props) => {
  const isCart = tokenPrimaryOffer.cards.length > 1;
  return (
    <>
      <SectionTitle>
        <FormattedMessage {...(isCart ? message : transferMarket.instantBuy)} />
      </SectionTitle>
      {tokenPrimaryOffer.cards.map(nft => (
        <TokenName key={nft.slug} card={nft} withLink />
      ))}
    </>
  );
};

TransactionsPrimaryOffer.fragments = {
  tokenPrimaryOffer: gql`
    fragment TransactionsPrimaryOffer_tokenPrimaryOffer on TokenPrimaryOffer {
      id
      cards: anyCards {
        slug
        ...TokenName_anyCard
      }
    }
    ${TokenName.fragments.anyCard}
  ` as TypedDocumentNode<TransactionsPrimaryOffer_tokenPrimaryOffer>,
};
